import createConverter from './lib/create_converter';
import KbVariable from 'models/kb_variable';

export default createConverter(KbVariable);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/kb_variable_converter.js